import { combineReducers } from 'redux';
import contract from './contract';
import login from './login';

export default combineReducers({ contract, login });
